"use client";

import { useState } from "react";
import { Plus, X, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Controlunitfaq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const faqs = [{
    question: "Welche Steuergeräte können geklont werden?",
    answer: "Je nach Fahrzeug und Steuergerät können unter anderem Motorsteuergeräte, Getriebesteuergeräte, Airbagsteuergeräte, Kombiinstrumente, Komfortsteuergeräte, ABS-/ESP-Steuergeräte sowie weitere Steuergeräte geklont oder deren Daten übertragen werden. Ob Ihr Steuergerät unterstützt wird, prüfen wir gerne vorab."
  }, {
    question: "Können Sie auch Steuergeräte klonen, wenn das Original defekt ist?",
    answer: "Ja, wir sind spezialisiert auf das Klonen und die Reparatur von Steuergeräten. Wir übertragen die Daten präzise auf ein Ersatzgerät, um eine reibungslose Funktion ohne aufwendige Neucodierung zu gewährleisten"
  }, {
    question: "Bieten Sie auch einen mobilen Vor-Ort-Service an?",
    answer: "Ja, unser mobiler Vor-Ort-Service ist ein zentraler Bestandteil unseres Leistungsversprechens. Wir kommen direkt zu Ihrem Standort – ob nach Hause, zur Arbeitsstelle oder im Pannenfall direkt an den Einsatzort. Mit unserer voll ausgestatteten mobilen Diagnoseeinheit führen wir Programmierungen, Schlüsselanpassungen und Steuergeräte-Checks direkt vor Ort durch, sodass Ihnen zeitaufwendige Werkstattbesuche und Abschleppkosten erspart bleiben."
  }, {
    question: "Können Sie Steuergeräte klonen, die nicht mehr lieferbar sind?",
    answer: "Absolut. Das Klonen von Steuergeräten ist eine unserer Kernkompetenzen. Wir können Daten von einem defekten Steuergerät auf ein gebrauchtes oder neues Ersatzteil übertragen, selbst wenn das Originalteil vom Hersteller nicht mehr produziert wird. Dies spart Ihnen hohe Kosten für neue Komponenten."
  }, {
    question: "Wie schnell kann ich einen Termin für eine Reparatur erhalten?",
    answer: "Wir legen großen Wert auf schnelle Reaktionszeiten. In den meisten Fällen können wir Ihnen innerhalb von 6-24 Stunden einen Termin anbieten. Bei Notfällen versuchen wir, Sie so schnell wie möglich in unseren Zeitplan aufzunehmen, damit Ihr Fahrzeug nicht unnötig lange ausfällt."
  }, {
    question: "Arbeiten Sie an allen Fahrzeugmarken?",
    answer: "Wir decken ein breites Spektrum an Fahrzeugmarken ab, von gängigen europäischen Modellen bis hin zu spezialisierten Importfahrzeugen. Unsere Ausrüstung wird regelmäßig aktualisiert, um auch die neuesten Wegfahrsperren- und Steuergerätetechnologien zu unterstützen. Fragen Sie uns einfach nach Ihrem spezifischen Modell."
  }, {
    question: "Gibt es eine Garantie auf Ihre Dienstleistungen?",
    answer: "Qualität und Zuverlässigkeit stehen bei uns an erster Stelle. Auf alle unsere Programmierungen und Reparaturen gewähren wir eine Garantie. Bei Problemen stehen wir mit einer schnellen Lösung zur Verfügung."
  }, {
    question: "Welche weiteren Services bietet CarFlowDE an?",
    answer: "Wir erweitern unser Portfolio kontinuierlich. Neben Schlüssel- und Steuergeräteservices arbeiten wir bereits an Lösungen für die Diagnose komplexer Elektronikfehler. Bleiben Sie gespannt auf unsere kommenden Service-Updates."
  }];
  const toggle = (i: number) => {
    setOpenIndex(openIndex === i ? null : i);
  };
  return <section data-section-id="3597" id="controlunitfaq" className="relative bg-cover bg-center bg-no-repeat text-foreground py-24 md:py-32 px-6 md:px-10 lg:px-16">
      <div className="absolute inset-0 bg-background z-0" />
      <div className="relative z-10 max-w-7xl mx-auto">
        <div ref={ref} className={`grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          {}
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-32">
              <p className="font-mono text-xs uppercase tracking-[0.25em] mb-8" style={{
              color: "var(--chart-1)"
            }}>
                03 — Support
              </p>
              <h2 className="font-default text-5xl md:text-6xl font-semibold leading-[1.05] mb-8 tracking-tighter">
                Häufige <span className="italic font-normal">Fragen.</span>
              </h2>
              <p className="font-default text-base leading-relaxed mb-10 max-w-md" style={{
              color: "var(--muted-foreground)"
            }}>
                Hier finden Sie Antworten auf die wichtigsten Fragen zu unseren Dienstleistungen. Für individuelle Anliegen stehen wir Ihnen jederzeit zur Verfügung.
              </p>
              <Link to="/ContactPage" className="group inline-flex items-center gap-3 font-default text-xs uppercase tracking-[0.2em] text-foreground hover:text-primary transition-colors duration-300">
                <span className="border-b border-foreground/30 group-hover:border-primary pb-1 transition-colors duration-300">
                  Haben Sie weitere Fragen? Kontaktieren Sie uns
                </span>
                <ArrowRight className="w-3.5 h-3.5 transition-transform duration-300 group-hover:translate-x-1" style={{
                color: "var(--primary)"
              }} />
              </Link>
            </div>
          </div>

          {}
          <div className="lg:col-span-7">
            <div className="border-t border-border">
              {faqs.map((faq, i) => {
              const isOpen = openIndex === i;
              const numeral = String(i + 1).padStart(2, "0");
              return <div key={i} data-index={i} className="border-b border-border">
                    <button type="button" onClick={() => toggle(i)} className="w-full py-7 flex items-start gap-5 md:gap-8 text-left group cursor-pointer" aria-expanded={isOpen}>
                      <span className="font-default italic text-base md:text-lg tabular-nums shrink-0 pt-1 transition-all duration-400" style={{
                    color: "var(--primary)",
                    opacity: isOpen ? 1 : 0.7
                  }}>
                        {numeral}
                      </span>

                      <span className="flex-1 font-default text-xl md:text-[1.35rem] leading-snug font-semibold tracking-tighter" style={{
                    color: "var(--foreground)"
                  }}>
                        {faq.question}
                      </span>

                      <span className="shrink-0 pt-1.5 transition-transform duration-400" style={{
                    color: "var(--primary)",
                    transform: isOpen ? "rotate(90deg)" : "rotate(0deg)"
                  }}>
                        {isOpen ? <X className="w-4 h-4" strokeWidth={1.25} /> : <Plus className="w-4 h-4" strokeWidth={1.25} />}
                      </span>
                    </button>

                    <div className="grid transition-all duration-[400ms] ease-out" style={{
                  gridTemplateRows: isOpen ? "1fr" : "0fr",
                  opacity: isOpen ? 1 : 0
                }}>
                      <div className="overflow-hidden">
                        <div className="pl-10 md:pl-14 pr-8 pb-8 max-w-2xl">
                          <p className="font-default text-base leading-relaxed" style={{
                        color: "var(--muted-foreground)"
                      }}>
                            {faq.answer}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>;
            })}
            </div>
          </div>
        </div>
      </div>
    </section>;
}